(() => {
  function initialize(root) {
    if (root.dataset.ready) return;
    const photos = Array.from(root.querySelectorAll('[data-photo]'));
    const image = root.querySelector('.yj-pdp__main-image');
    const zoom = root.querySelector('[data-zoom]');
    const dialog = root.querySelector('[data-lightbox]');
    const fullImage = root.querySelector('[data-lightbox-image]');
    let current = 0;
    let opener = null;
    if (!photos.length || !image) return;
    function select(index, reveal = true) {
      current = (index + photos.length) % photos.length;
      const photo = photos[current];
      image.removeAttribute('srcset');
      image.src = photo.dataset.src;
      image.alt = photo.dataset.alt;
      zoom.href = photo.dataset.full;
      photos.forEach((item, i) => item.setAttribute('aria-pressed', String(i === current)));
      root.querySelector('[data-photo-count]').textContent = `${current + 1} / ${photos.length}`;
      if (reveal) {
        const strip = photo.parentElement;
        const left = photo.offsetLeft - strip.offsetLeft;
        if (left < strip.scrollLeft || left + photo.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = left;
      }
      if (dialog.open) updateFullImage();
    }
    function updateFullImage() {
      const selected = current;
      const thumbnail = photos[selected].querySelector('img');
      fullImage.src = image.complete && image.naturalWidth ? image.currentSrc : thumbnail.currentSrc;
      fullImage.alt = photos[current].dataset.alt;
      root.querySelector('[data-lightbox-count]').textContent = `Machine photo ${current + 1} / ${photos.length}`;
      const fullSize = new Image();
      fullSize.onload = () => { if (dialog.open && current === selected) fullImage.src = fullSize.src; };
      fullSize.src = photos[selected].dataset.full;
    }
    function close() { dialog.close(); }
    photos.forEach((photo, i) => photo.addEventListener('click', () => select(i)));
    root.querySelector('[data-photo-prev]').addEventListener('click', () => select(current - 1));
    root.querySelector('[data-photo-next]').addEventListener('click', () => select(current + 1));
    zoom.addEventListener('click', event => {
      if (typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      opener = zoom;
      updateFullImage();
      dialog.showModal();
    });
    root.querySelector('[data-lightbox-close]').addEventListener('click', close);
    root.querySelector('[data-lightbox-prev]').addEventListener('click', () => select(current - 1));
    root.querySelector('[data-lightbox-next]').addEventListener('click', () => select(current + 1));
    dialog.addEventListener('close', () => { if (opener) opener.focus({preventScroll:true}); });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); select(current + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    const stage = root.querySelector('.yj-pdp__photo-stage');
    let touchStart = null;
    stage.addEventListener('touchstart', event => { touchStart = event.touches.length === 1 ? {x:event.touches[0].clientX,y:event.touches[0].clientY} : null; }, {passive:true});
    stage.addEventListener('touchend', event => {
      if (!touchStart) return;
      const end = event.changedTouches[0];
      const dx = end.clientX - touchStart.x;
      const dy = end.clientY - touchStart.y;
      if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) select(current + (dx < 0 ? 1 : -1));
      touchStart = null;
    }, {passive:true});
    root.dataset.ready = 'true';
  }
  document.querySelectorAll('[data-yj-product-layout]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-yj-product-layout]').forEach(initialize));
})();
